import { useState } from 'react';
import { Tooltip } from 'antd';
import { FaHome } from 'react-icons/fa';

const ForestDataMapReset = (props) => {
  const [hover, setHover] = useState(false);

  const toggleHover = () => {
    setHover(!hover);
  };

  const onReset = () => {
    let view = props.map.getView();
    //view.setCenter([-118.4194, 33.9592]);  // southern CA
    view.setCenter([-119.4179, 36.7783]);
    // view.setZoom(7.8);
    view.setZoom(6.2);

    for (var i = 0; i < props.layers.length; i++) {
      let layer = props.layers[i];
      if (layer.getVisible()) {
        layer.getSource().refresh();
      }
    }
  };

  let rootStyle = props.style;
  if (rootStyle === undefined) {
    rootStyle = {
      ...rootStyle,
      position: 'absolute',
      top: '68px',
      left: '7px',
      borderRadius: '6px',
      backgroundColor: hover ? '#3D5249' : '#2C3E37',
      border: '3px solid rgba(255, 255, 255, 0.72)',
      display: 'flex',
      width: '32px',
      minHeight: '32px',
      justifyContent: 'center',
      alignItems: 'center',
    };
  }

  return (
    <div>
      <div
        style={rootStyle}
        onMouseEnter={toggleHover}
        onMouseLeave={toggleHover}
      >
        <Tooltip title="Reset Map" placement="right">
          <button
            onClick={onReset}
            aria-label="Reset map to default view"
            style={{
              color: 'white',
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '24px',
              minHeight: '24px',
            }}
          >
            <FaHome aria-hidden="true" />
          </button>
        </Tooltip>
      </div>
    </div>
  );
};

export default ForestDataMapReset;
